import React from "react";
import comingSoon from "../assets/images/coming-soon.webp"
import { useNavigate } from "react-router-dom";

const UnderDevelopment = () => {
    const navigate = useNavigate()
    return (
        <div className="flex flex-col items-center justify-center bg-gray-100 text-center" style={{ height: '95vh' }}>
            <img
                src={comingSoon}
                width={200}
                alt="Page Under Development"
                className="mb-6 rounded"
            />
            <h1 className="text-4xl font-extrabold text-gray-800 mb-4">Page Under Development</h1>
            <p className="text-lg text-gray-600">
                We're working hard to bring this page to life. Stay tuned!
            </p>
            <span className="text-blue-500 cursor-pointer" onClick={() => navigate(-1)}>Go Back</span>
        </div>
    );
};

export default UnderDevelopment;
